<template>
  <div class="modelTheOld">
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="demo-form-inline"
    >
      <el-form-item label="疑似传销窝点出现人次阈值">
        <el-input-number
          v-model="tableParams.name"
          :min="0"
          :max="150"
          controls-position="right"
        />
        <span class="spanmargin">岁 —</span>
        <el-input-number
          v-model="tableParams.name"
          :min="0"
          :max="150"
          controls-position="right"
        /><span class="spanmargin">岁</span>
        <!-- @change="handleChange" -->
      </el-form-item>
      <el-form-item label="疑似未抓拍天数阈值≥" prop="">
        <el-input-number
          v-model="tableParams.name"
          :min="0"
          :max="5"
          controls-position="right"
        /><span class="spanmargin">天</span>
      </el-form-item>
      <el-form-item class="bottomBtn">
        <h-button type="primary">保存</h-button>
        <h-button type="">取消</h-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
export default defineComponent({
  name: "modelTheOld",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      tableParams: {
        name: ""
      },
      num: 1
    });
    const refData = toRefs(data);
    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
.modelTheOld {
  .demo-form-inline {
    display: flex;
    flex-direction: column;
  }
  .bottomBtn {
    margin-left: 150px;
  }
}
.spanmargin {
  margin: 0 10px;
}
</style>
